import {
  Configuration,
  ContactsApi,
  CurrenciesApi,
  DashboardsApi,
  DdStreamOptionsApi,
  InteractionsApi,
  ReferenceListsApi,
  SharepointLinksApi,
  TargetsApi,
  UsersApi,
} from "@socotec.io/sight-back-sdk";
import { useOidcStore } from "vue3-oidc";

const configuration = new Configuration({
  basePath: import.meta.env.VITE_APP_BACK_URL,
  accessToken: () => useOidcStore().state.value.token,
});

export const useTargetsApi = () => new TargetsApi(configuration);
export const useReferenceListsApi = () => new ReferenceListsApi(configuration);
export const useUsersApi = () => new UsersApi(configuration);
export const useInteractionsApi = () => new InteractionsApi(configuration);
export const useContactsApi = () => new ContactsApi(configuration);
export const useSharepointLinksApi = () => new SharepointLinksApi(configuration);
export const useCurrenciesApi = () => new CurrenciesApi(configuration);
export const useDdStreamOptionsApi = () => new DdStreamOptionsApi(configuration);
export const useDashboardsApi = () => new DashboardsApi(configuration);
